<div class="transition-all" v-bind:class="{ 'opacity-0': hidden }">
    Saved 
</div>
